<template>
    <div class="app-box">
        <vue-scroll-snap @scroll="checkScroll">
            <div class="item" id="block1" ref="block1"><img src="/img/otc/otc-300-1.jpg" class="imgs" /></div>
            <div class="item" id="block2" ref="block2">
                <img src="/img/otc/otc-300-2.jpg" class="imgs" />
            </div>
            <!-- <div class="item" id="block3" ref="block3"><img src="/img/otc/blf-2.jpg" class="imgs" /></div> -->
        </vue-scroll-snap>
        <div class="circle-box">
            <div class="">
                <div :class="item===1?'circle actived':'circle'" v-for="item in arr">
                </div>
            </div>
        </div>
        <img src="/img/otc/img-arrow-down.png" class="imgs_arrow" ></img>
    </div>
</template>

<script setup>

import { ref, onMounted, onUnmounted } from 'vue'
import VueScrollSnap from "vue-scroll-snap";

const arr = ref([1, 0]);
const block1 = ref(null)
const block2 = ref(null)
const block3 = ref(null)

const checkScroll = (event) => {
    //console.log(event.target);


    let top = event.target.scrollTop
    console.log(top)
    // 检查 block1
    if (block1.value) {
        const block1Top = block1.value.offsetTop
        const isBlock1InView = top <= block1Top + block2.value.clientHeight
        if (isBlock1InView) {
            arr.value = [1, 0]
        }
        console.log('block1Top=' + block1Top)
        console.log('Block1 in view:', isBlock1InView)
    }

    // 检查 block2
    if (block2.value) {
        const block2Top = block2.value.offsetTop
        console.log('block2Top=' + block2Top)
        const isBlock2InView = top > block2Top-4 && top <= block2Top + block2.value.clientHeight
        console.log('Block2 in view:', isBlock2InView)
        if (isBlock2InView) {
            arr.value = [0, 1]
        }
    }

    // 检查 block3
    // if (block3.value) {
    //     const block3Top = block3.value.offsetTop

    //     console.log('block3Top=' + block3Top)
    //     const isBlock3InView = top > block3Top-4 && top <= block3Top + block2.value.clientHeight
    //     console.log('Block3 in view:', isBlock3InView)
    //     if (isBlock3InView) {
    //         arr.value = [0, 0, 1]
    //     }
    // }
}
onMounted(() => {
    //window.addEventListener('scroll', checkScroll)
    // 初始检查一次
    //checkScroll()
})

onUnmounted(() => {
    //window.removeEventListener('scroll', checkScroll)
})
</script>
<style lang="scss" scoped>
.app-box {
    width: 100vw;
    height: 100vh;
}

.item {
    /* Set the minimum height of the items to be the same as the height of the scroll-snap-container.*/

    margin: 0px;
    padding: 0px;
    margin-top: -4px;
}

.imgs {
    width: 100vw;
    margin: 0px;
    padding: 0px;
}

.pages {
    display: flex;
    height: 100vh;
    width: 100vw;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}

.scroll-snap-container {
    height: 100vh;
    width: 100vw;
}

.circle-box {
    width: 18px;
    position: fixed;
    left: 20px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    top: 0px;

    .circle {
        width: 10px;
        height: 10px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 10px;
    }
    .actived{
         background-color: red;
    }
}
.imgs_arrow{
    width: 44px;
    height: 44px;
    position: fixed;
    bottom: 20px;
    left: calc((100vw - 44px) / 2);
    animation: bounce 2s ease-in-out infinite;
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-20px);
  }
  50% {
    transform: translateY(10px);
  }
  75% {
    transform: translateY(-5px);
  }
}


</style>